import { isEmptyValue } from '../../../../../shared/utils/jsUtils';

export const getValidDepends = (depends: unknown[]): number[] => {
  const isInvalid = depends.some((value) => !!value && typeof value !== 'number');
  if (isInvalid) {
    console.error('use incorrect deps config, only numbers allowed', depends);
  }

  return depends.filter(
    (value) => !isEmptyValue(value) && typeof value === 'number',
  ) as number[];
};
